import { NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '@app/module-import.guard';
import {AuthGuard} from "@app/auth.guard";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {JwtInterceptor} from "@app/interceptor/jwt.interceptor";
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { MessageService } from 'primeng/api';
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { TraceErrorHandler } from './telemetry/trace-error.handler';
import { TraceInterceptor } from './telemetry/trace.interceptor';
import { TraceService } from './telemetry/trace.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    AuthGuard,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    //! La bitácora va TERCERA, después de Error. Angular encadena con reduceRight, así que la
    //! respuesta viaja al revés que la petición: siendo el último registrado, su catchError es el
    //! primero en ver un error — antes de que ErrorInterceptor cierre la sesión en un 401 y vacíe
    //! la bitácora justo cuando más hace falta.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TraceInterceptor,
      multi: true,
    },
    //* Los errores de JavaScript también entran a la bitácora. Sigue llegando todo a la consola.
    { provide: ErrorHandler, useClass: TraceErrorHandler },
    //* Sin este arranque el servicio solo nacería con la primera petición y se perderían la
    //* navegación inicial y los clics previos, que son la mitad de lo que explica un fallo.
    {
      provide: APP_INITIALIZER,
      useFactory: (trace: TraceService) => () => trace.start(),
      deps: [TraceService],
      multi: true,
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
